module.exports = __webpack_public_path__ + "static/media/20-5.386acc05.mp3";